<!-- 隐私政策 -->
<template>
  <div class="agreement-page">
    <div class="agreement" v-html="contentHtml"></div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const agreementTexts = {
  'zh-Hans': `
    <h1>隐私政策</h1>
    <p>更新时间：2026年9月28日</p>
    <p>欢迎使用由香港推衍智能科技有限公司（下称 “我方” 或 “我们”）开发并运营的 LIVEO APP（下称 “本应用”）。本隐私政策向用户完整说明我方对个人信息的收集、使用、存储、共享及保护机制，同时列明您所享有的各项信息相关权利，帮助您充分知悉相关规则，自主决定是否向我们提供个人信息。</p>
    <p>在使用本应用全部服务之前，请完整阅读本隐私政策全部条款。<strong>如果您不认可本政策当中任意条款，请立刻停止使用本应用。</strong></p>
    <h2>一、总则</h2>
    <p>我们处理您的个人信息严格遵循合法、正当、最小必要原则，仅为实现本应用直播核心业务采集数据，不会获取与产品服务无关的用户信息。</p>
    <p>本政策适用于您使用 LIVEO APP 全部场景，涵盖注册登录、观看直播、开播、评论互动、充值消费、客服咨询等全部功能；对于外部网页、第三方 SDK 的数据处理行为，优先适用对应第三方自身的隐私规范。</p>
    <h2>二、收集个人信息类别</h2>
    <p>我们仅在获得您授权，或是为完成服务所必需的前提下采集对应信息，信息来源分为您主动提交、系统自动采集两大类。</p>
    <h3>2.1 账号注册与登录获取信息</h3>
    <p>为帮助您创建、登录 LIVEO 直播账号，保障账号安全，正常使用直播及互动相关能力，我们可能会收集如下信息：</p>
    <p>2.1.1 手机号码、短信验证码：用于账号注册以及身份校验，防范恶意批量注册等安全风险；</p>
    <p>2.1.2 用户自定义昵称、头像图片：由您自主设置，用于直播场景内身份展示，便于其他用户识别、开展互动。</p>
    <h3>2.2 设备、网络及日志数据</h3>
    <p>当您运行本应用，系统会自动记录设备参数、网络环境以及操作日志；目的是保障程序稳定运行、优化直播体验、抵御各类安全风险。</p>
    <p>2.2.1 设备信息：设备型号、操作系统版本、设备识别标识符（例如 OAID、Android ID、IDFA 等）、设备运行状态。该类标识符仅用于区分设备，不会直接绑定您的真实个人身份；</p>
    <p>2.2.2 网络信息：IP 地址、MAC 地址、网络类型（WiFi、4G/5G 等）、网络质量状态，用于评估网络环境，保障直播播放流畅；</p>
    <p>2.2.3 操作与崩溃日志：记录您的使用行为，例如进入 / 退出直播间、发送评论、点赞，以及应用崩溃、加载异常等，用于定位程序缺陷，迭代优化产品性能。</p>
    <h3>2.3 用户主动上传、提交的信息</h3>
    <p>在使用直播相关功能时，根据功能需要，您可能主动向平台提交以下内容：</p>
    <p>2.3.1 直播产出内容：相机采集的直播画面、麦克风录制音频、手动上传相册图片、评论文字、互动消息等；</p>
    <p>2.3.2 客服反馈资料：当您通过客服渠道咨询、提建议、发起投诉时，您可能提供姓名、联系手机号、邮箱以及问题描述，协助我方处理您的诉求。</p>
    <h3>2.4 设备权限对应的采集信息</h3>
    <p>为实现直播核心功能，本应用会向您申请设备权限，您拥有同意或拒绝授权的自主选择权。拒绝某项权限仅会造成对应功能不可用，不会干扰其余模块正常使用。</p>
    <p>2.4.1 相机权限：仅在您发起直播拍摄时唤起，用于采集直播画面；应用不会在后台闲置状态私自调取相机；</p>
    <p>2.4.2 麦克风权限：只在开启直播、发送语音消息场景启用，负责录制音频；后台状态不会录制任何声音；</p>
    <p>2.4.3 相册访问权限：选择上传图片作为直播封面、背景或者互动素材时读取选中图片，不会主动全盘扫描相册内全部文件。</p>
    <h2>三、个人信息的使用范围</h2>
    <p>我们获取的全部个人信息，仅限下文列明的正当业务场景使用。如果后续需要超出本政策范围使用数据，会另行获得您的明确许可。</p>
    <p>3.1 完成账号创建、登录和身份核验，防范账号盗用、恶意注册，保障账号安全；</p>
    <p>3.2 提供直播核心服务，包含画面采集、音频录制、内容展示、评论、点赞、连麦互动，保障直播业务正常运转；</p>
    <p>3.3 改善产品体验，依托操作记录、设备与网络信息排查程序故障，优化直播流畅度，迭代功能设计；</p>
    <p>3.4 开展安全风控，依靠设备信息、行为日志识别作弊、违规直播、盗号等异常行为，维护平台秩序，保护全体用户合法权益；</p>
    <p>3.5 处理客服请求，依据您提交的联系方式回复咨询、处理投诉，跟进事项处理进度；</p>
    <p>3.6 推送必要系统通知，包含账号安全提醒、开播提示、互动消息、政策更新公告；</p>
    <p>3.7 履行法定义务，配合司法、监管机构调查取证，落实实名认证、违规事件核查等法定要求。</p>
    <h2>四、个人信息的共享、转让与公开披露</h2>
    <p>我们会严格保护您的个人信息，遵循合法、正当、最小必要原则；除非符合本政策约定，不会随意对外共享、转让、公开用户信息。</p>
    <h3>4.1 信息共享适用情形</h3>
    <p>仅在如下场景，我方会把必要信息交付第三方，同时会审核第三方资质，要求其承担信息保密义务：</p>
    <p>4.1.1 第三方 SDK 服务商：为实现直播推流、数据统计、消息推送等产品能力，本应用集成第三方 SDK 组件。SDK 仅采集完成对应功能必不可少的数据，各服务商需要遵循自身隐私规范处理用户数据。</p>
    <p>4.1.1.1 直播 SDK：完成推流、拉流、连麦交互，会获取设备参数、网络条件以及直播音视频内容；</p>
    <p>4.1.1.2 统计 SDK：统计产品活跃、直播时长、用户操作行为，仅采集设备、日志信息，不采集可识别个人身份的敏感数据，用于产品迭代参考；</p>
    <p>4.1.1.3 推送 SDK：负责下发开播通知、账号安全提醒，获取设备标识符、推送运行日志，保障通知正常送达。</p>
    <p>4.1.2 集团关联企业：如果我方关联企业需要协助提供服务（账号互通、收益结算等），会先征得您同意之后再共享必要数据，关联企业同样受本隐私政策约束。</p>
    <p>4.1.3 法定及监管要求：遇到法律规定、司法或主管部门明确要求时，我方将依法提交所需个人信息，配合调查与合规核查。</p>
    <h3>4.2 信息转让</h3>
    <p>原则上我方不会主动转让您的个人信息。如发生公司合并、分立、收购、资产处置，进而需要移交个人信息，我方会通过应用弹窗、公告至少提前三十日告知用户，取得您明确同意之后再执行转让，同时要求受让方承担同等标准的隐私保护责任。若受让方未能履行保护义务，我方依法承担相应连带责任。</p>
    <h3>4.3 公开披露</h3>
    <p>未经您明确许可，我方不会对外公开您的个人信息，除非符合以下情形：</p>
    <p>4.3.1 在您主动授权前提下，按照您的意愿公开相关内容，例如您自行对外分享直播画面；</p>
    <p>4.3.2 为维护公共利益、平台秩序或者保护用户权益，处置违规事件时发布处理结果，但会屏蔽全部可以定位到个人身份的敏感资料。</p>
    <h3>4.4 特别说明</h3>
    <p>我方不会售卖、出租、出借用户个人信息，也不会将个人数据应用于任何违法场景。</p>
    <h2>五、第三方 SDK 清单</h2>
    <p>为保障本应用稳定运行，本产品集成以下第三方 SDK；后续如果新增第三方组件，我方会通过应用公告更新本条款。</p>
    <p>SDK名称：ZEGO_实时音视频 SDK</p>
    
    <p>使用目的：提供语音通话、直播推流拉流服务</p>
    <p>收集的个人信息类型：网络连接信息、相机、音频、外部存储读写权限</p>
    <p>合作方主体：深圳市即构科技有限公司</p>
    <p>收集方式：SDK自行采集</p>
    <p>合作方隐私政策：<a href="https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy" target="_blank" rel="noopener noreferrer">https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy</a></p>
    <p>SDK名称：ZEGO_AI美颜 SDK</p>
    
    <p>使用目的：提供直播美颜、特效功能</p>
    <p>收集的个人信息类型：面部特征值信息、虹膜、用户名、用户 ID 、操作日志、 App 版本号、设备 ID 、操作系统类型、 IP 地址</p>
    <p>合作方主体：深圳市即构科技有限公司</p>
    <p>收集方式：SDK自行采集</p>
    <p>合作方隐私政策：<a href="https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy" target="_blank" rel="noopener noreferrer">https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy</a></p>
    <p>您可以点击上面链接查阅各服务商的隐私政策。如您不认可某款 SDK 的信息采集行为，您可以选择不使用该 SDK 对应的功能，或者直接卸载本应用。</p>
    <h2>六、信息存储与安全防护机制</h2>
    <h3>6.1 数据存储</h3>
    <ul>
    <li><strong>存储位置</strong>：我们收集到的个人信息存储于新加坡阿里云服务器，满足个人信息跨境存储相关法律法规。若因服务需要，需将信息存储到其他境外地区，会提前获得您的明确同意，并按照相关规定进行安全评估及备案。</li>
    <li><strong>存储期限</strong>：遵循最小必要、最短留存原则，不同类别数据保存周期如下：</li>
    </ul>
    <p>1. 账号基础信息（手机号、昵称、头像等）：账号存续期间持续保存；账号注销完成后立即删除或者做匿名化处理；</p>
    <p>2. 直播内容、互动留言记录：直播结束后留存 30 日；用户手动删除内容则即刻清除；</p>
    <p>3. 设备与操作日志：最长保存 6 个月，到期自动匿名化，移除所有能够识别个人身份的字段；</p>
    <p>4. 主播实名认证资料：账号注销之后留存 3 个月，到期依法删除。</p>
    <h3>6.2 信息安全保护措施</h3>
    <p>我们高度重视个人信息安全，同时采用技术手段与内部管理制度，防范信息泄露、篡改、丢失风险。</p>
    <p>6.2.1 技术防护：敏感信息加密存储与加密传输，部署防火墙、入侵检测、数据备份机制，抵御网络攻击；</p>
    <p>6.2.2 内部管理：制定严格的数据安全制度，严格管控员工的数据访问权限；对接触个人信息的人员开展隐私培训考核，签署保密协议，禁止私自获取、外泄用户资料；</p>
    <p>6.2.3 安全事件应急：一旦发生个人信息泄露、篡改、丢失等安全事故，我方会立刻启动应急方案，采取补救手段避免损害扩大，并按照法规要求通知受影响用户与监管机构。</p>
    <h2>七、用户个人信息相关权利</h2>
    <p>依据相关法律规范，对于您自身的个人信息，您享有查询、更正、删除、账号注销、撤回授权、投诉申诉等权利，我方提供便捷渠道供您行使权利。</p>
    <p><strong>7.1 查询与修改信息</strong>：您可以进入应用内「我的」‑「个人资料」页面，自行调整昵称、头像、手机号；如需调取更深层次的信息处理记录，可以联系客服处理；</p>
    <p><strong>7.2 删除个人内容</strong>：直播片段、评论、互动消息，您可直接在APP内手动删除；如需清除设备日志这类系统级记录，需要提交客服，完成身份核验后由我方协助处理；</p>
    <p><strong>7.3 账号注销</strong>：进入「我的」&gt;「账号设置」选择账号注销，跟随页面指引完成申请流程。账号注销生效后，我方将清除或者匿名化全部对应的个人信息；</p>
    <p><strong>7.4 撤回权限授权</strong>：在手机系统设置关闭相机、麦克风、相册权限即可完成撤回；撤回后不再采集该权限对应数据，但不会影响此前已经留存的信息，其余功能不受干扰；</p>
    <p><strong>7.5 关闭消息推送</strong>：可以在本应用「我的」‑「消息设置」关闭推送，也可以在操作系统设置禁止本应用发送通知；</p>
    <p><strong>7.6 投诉与申诉</strong>：如果您认为我方信息处理行为损害自身权益，或是存有疑问，请联系我们提交反馈；我们会在收到请求起 7 个工作日内完成回复处理。</p>
    <h2>八、未成年人信息保护</h2>
    <p>8.1 本应用并非面向未满十八周岁未成年人设计。如果您尚未年满 18 周岁，请在法定监护人陪同下阅读本隐私政策，取得监护人同意之后才可以使用本应用；未成年人不允许开通主播直播权限。</p>
    <p>8.2 我方不会主动收集未成年人的个人信息。如果我方发现未成年人在没有监护人许可的前提下提交个人资料，我方会尽快删除相关信息并尝试通知监护人。</p>
    <p>8.3 监护人如果发现未成年人未经许可使用本应用并且发生信息泄露，可联系我们，我们将配合核验身份，执行删除信息、限制账号等对应处置。</p>
    <h2>九、隐私政策版本更新</h2>
    <p>随着法律法规修订或者产品功能迭代，我方有权调整、补充本隐私政策条款，新版本将进一步完善个人信息保护机制。</p>
    <p>9.1 更新告知：政策修订完毕之后，我方通过应用弹窗、平台公告、消息通知向用户公示，新版本自发布当日生效；</p>
    <p>9.2 用户选择权：如果您不接受更新后的隐私政策，应当停止使用本应用；继续使用产品即代表您认可新版本全部条款。</p>
    <h2>十、联系渠道</h2>
    <p>如对本隐私政策存有疑问、建议，或是需要行使个人信息权利、提交投诉申诉，欢迎通过以下渠道与我方取得联系。</p>
    <ul>
    <li>运营主体：香港推衍智能科技有限公司</li>
    <li>联系地址：RM A8, UNIT A, 5/F, TAK WING INDUSTRIAL BUILDING, 3 TSUN WEN ROAD, TUEN MUN, HONG KONG</li>
    <li>联系电话：+852 51427983</li>
    <li>联系邮箱：dbandrewxu@gmail.com</li>
    </ul>
    <p>我方将在收到您消息后的 7 个工作日内予以回复并处理。</p>
    <p>本隐私政策自发布之日起生效。</p>
  `,
  'zh-Hant': `
    <h1>隱私政策</h1>
    <p>更新時間：2026年9月28日</p>
    <p>歡迎使用由香港推衍智能科技有限公司（下稱「我方」或「我們」）開發並運營的LIVEO APP（下稱「本應用」）。本隱私政策向用戶完整說明我方對個人信息的收集、使用、儲存、共享及保護機制，同時列明您所享有的各項信息相關權利，幫助您充分知悉相關規則，自主決定是否向我們提供個人信息。</p>
    <p>在使用本應用全部服務之前，請完整閱讀本隱私政策全部條款。<strong>如果您不認可本政策當中任意條款，請立刻停止使用本應用。</strong></p>
    <h2>一、總則</h2>
    <p>我們處理您的個人信息嚴格遵循合法、正當、最小必要原則，僅為實現本應用直播核心業務採集數據，不會獲取與產品服務無關的用戶信息。</p>
    <p>本政策適用於您使用 LIVEO APP 全部場景，涵蓋註冊登錄、觀看直播、開播、評論互動、充值消費、客服諮詢等全部功能；對於外部網頁、第三方 SDK 的數據處理行為，優先適用對應第三方自身的隱私規範。</p>
    <h2>二、收集個人信息類別</h2>
    <p>我們僅在獲得您授權，或是為完成服務所必需的前提下採集對應信息，信息來源分為您主動提交、系統自動採集兩大類。</p>
    <h3>2.1 帳號註冊與登錄獲取資訊</h3>
    <p>為幫助您創建、登錄 LIVEO 直播帳號，保障帳號安全，正常使用直播及互動相關能力，我們可能會收集如下資訊：</p>
    <p>2.1.1 手機號碼、短訊驗證碼：用於帳號註冊以及身份校驗，防範惡意批量註冊等安全風險；</p>
    <p>2.1.2 用戶自定義暱稱、頭像圖片：由您自主設置，用於直播場景內身份展示，便於其他用戶識別、開展互動。</p>
    <h3>2.2 設備、網絡及日誌數據</h3>
    <p>當您運行本應用，系統會自動記錄設備參數、網絡環境以及操作日誌；目的是保障程式穩定運行、優化直播體驗、抵禦各類安全風險。</p>
    <p>2.2.1 設備資訊：設備型號、作業系統版本、設備識別標識符（例如 OAID、Android ID、IDFA 等）、設備運行狀態。該類標識符僅用於區分設備，不會直接綁定您的真實個人身份；</p>
    <p>2.2.2 網絡信息：IP 位址、MAC 位址、網絡類型（WiFi、4G/5G 等）、網絡質量狀態，用於評估網絡環境，保障直播播放流暢；</p>
    <p>2.2.3 操作與崩潰日誌：記錄您的使用行為，例如進入 / 退出直播間、發送評論、點讚，以及應用崩潰、加載異常等，用於定位程式缺陷，迭代優化產品性能。</p>
    <h3>2.3 用戶主動上傳、提交的資訊</h3>
    <p>在使用直播相關功能時，根據功能需要，您可能主動向平台提交以下內容：</p>
    <p>2.3.1 直播產出內容：相機採集的直播畫面、麥克風錄製音頻、手動上傳相冊圖片、評論文字、互動消息等；</p>
    <p>2.3.2 客服反饋資料：當您透過客服渠道諮詢、提建議、發起投訴時，您可能提供姓名、聯繫手機號、郵箱以及問題描述，協助我方處理您的訴求。</p>
    <h3>2.4 設備權限對應的採集資訊</h3>
    <p>為實現直播核心功能，本應用會向您申請設備權限，您擁有同意或拒絕授權的自主選擇權。拒絕某項權限僅會造成對應功能不可用，不會干擾其餘模塊正常使用。</p>
    <p>2.4.1 相機權限：僅在您發起直播拍攝時喚起，用於採集直播畫面；應用不會在後台閒置狀態私自調取相機；</p>
    <p>2.4.2 麥克風權限：只在開啟直播、發送語音訊息場景啟用，負責錄製音頻；後台狀態不會錄製任何聲音；</p>
    <p>2.4.3 相簿訪問權限：選擇上傳圖片作為直播封面、背景或者互動素材時讀取選中圖片，不會主動全盤掃描相簿內全部文件。</p>
    <h2>三、個人資訊的使用範圍</h2>
    <p>我們獲取的全部個人信息，僅限下文列明的正當業務場景使用。如果後續需要超出本政策範圍使用數據，會另行獲得您的明確許可。</p>
    <p>3.1 完成帳號創建、登錄和身份核驗，防範帳號盜用、惡意註冊，保障帳號安全；</p>
    <p>3.2 提供直播核心服務，包含畫面採集、音頻錄製、內容展示、評論、點讚、連麥互動，保障直播業務正常運轉；</p>
    <p>3.3 改善產品體驗，依托操作記錄、設備與網絡信息排查程序故障，優化直播流暢度，迭代功能設計；</p>
    <p>3.4 開展安全風控，依靠設備資訊、行為日誌識別作弊、違規直播、盜號等異常行為，維護平台秩序，保護全體用戶合法權益；</p>
    <p>3.5處理客服請求，依據您提交的聯繫方式回覆諮詢、處理投訴，跟進事項處理進度；</p>
    <p>3.6 推送必要系統通知，包含帳號安全提醒、開播提示、互動消息、政策更新公告；</p>
    <p>3.7 履行法定义務，配合司法、監管機構調查取證，落實實名認證、違規事件核查等法定要求。</p>
    <h2>四、個人信息的共享、轉讓與公開披露</h2>
    <p>我們會嚴格保護您的個人信息，遵循合法、正當、最小必要原則；除非符合本政策約定，不會隨意對外共享、轉讓、公開用戶信息。</p>
    <h3>4.1 資訊共享適用情形</h3>
    <p>僅在如下場景，我方會把必要信息交付第三方，同時會審核第三方資質，要求其承擔信息保密義務：</p>
    <p>4.1.1 第三方 SDK 服務商：為實現直播推流、數據統計、消息推送等產品能力，本應用集成第三方 SDK 組件。SDK 僅採集完成對應功能必不可少的数据，各服務商需要遵循自身隱私規範處理用戶數據。</p>
    <p>4.1.1.1 直播SDK：完成推流、拉流、連麥交互，會獲取設備參數、網絡條件以及直播音視頻內容；</p>
    <p>4.1.1.2 統計SDK：統計產品活躍、直播時長、用戶操作行為，僅採集設備、日誌信息，不採集可識別個人身份的敏感數據，用於產品迭代參考；</p>
    <p>4.1.1.3 推送SDK：負責下發開播通知、帳號安全提醒，獲取設備標識符、推送運行日誌，保障通知正常送達。</p>
    <p>4.1.2 集團關聯企業：如果我方關聯企業需要協助提供服務（帳號互通、收益結算等），會先徵得您同意之後再共享必要數據，關聯企業同樣受本隱私政策約束。</p>
    <p>4.1.3 法定及監管要求：遇到法律規定、司法或主管部門明確要求時，我方將依法提交所需個人資訊，配合調查與合規核查。</p>
    <h3>4.2 資訊轉讓</h3>
    <p>原則上我方不會主動轉讓您的個人信息。如發生公司合併、分立、收購、資產處置，進而需要移交個人信息，我方會通過應用彈窗、公告至少提前三十日告知用戶，取得您明確同意之後再執行轉讓，同時要求受讓方承擔同等標準的隱私保護責任。若受讓方未能履行保護義務，我方依法承擔相應連帶責任。</p>
    <h3>4.3 公開披露</h3>
    <p>未經您明確許可，我方不會對外公開您的個人資訊，除非符合以下情形：</p>
    <p>4.3.1 在您主動授權前提下，按照您的意願公開相關內容，例如您自行對外分享直播畫面；</p>
    <p>4.3.2 為維護公共利益、平台秩序或者保護用戶權益，處置違規事件時發佈處理結果，但會屏蔽全部可以定位到個人身份的敏感資料。</p>
    <h3>4.4 特別說明</h3>
    <p>我方不會售賣、出租、出借用戶個人信息，也不會將個人數據應用於任何違法場景。</p>
    <h2>五、第三方 SDK 清單</h2>
    <p>為保障本應用穩定運行，本產品集成以下第三方SDK；後續如果新增第三方組件，我方會通過應用公告更新本條款。</p>
    <p>SDK名稱：ZEGO_實時音視頻 SDK</p>
    
    <p>使用目的：提供語音通話、直播推流拉流服務</p>
    <p>收集的個人信息類型：網絡連接信息、相機、音頻、外部存儲讀寫權限</p>
    <p>合作方主體：深圳市即構科技有限公司</p>
    <p>收集方式：SDK自行採集</p>
    <p>合作方隱私政策：<a href="https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy" target="_blank" rel="noopener noreferrer">https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy</a></p>
    <p>SDK名稱：ZEGO_AI美顏 SDK</p>
    
    <p>使用目的：提供直播美顏、特效功能</p>
    <p>收集的個人信息類型：面部特徵值信息、虹膜、用戶名、用戶ID 、操作日誌、 App版本號、設備ID 、操作系統類型、 IP地址</p>
    <p>合作方主體：深圳市即構科技有限公司</p>
    <p>收集方式：SDK自行採集</p>
    <p>合作方隱私政策：<a href="https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy" target="_blank" rel="noopener noreferrer">https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy</a></p>
    <p>您可以點擊上面連結查閱各服務商的隱私政策。如您不認可某款SDK的資訊採集行為，您可以选择不使用該SDK對應的功能，或者直接卸載本應用。</p>
    <h2>六、信息存儲與安全防護機制</h2>
    <h3>6.1 數據存儲</h3>
    <ul>
    <li>存儲位置：我們收集到的個人信息存儲於新加坡阿里雲伺服器，滿足個人信息跨境存儲相關法律法規。若因服務需要，需將信息存儲到其他境外地區，會提前獲得您的明確同意，並按照相關規定進行安全評估及備案。</li>
    <li>存儲期限：遵循最小必要、最短留存原則，不同類別資料保存周期如下：</li>
    </ul>
    <p>1. 帳號基礎信息（手機號、暱稱、頭像等）：帳號存續期間持續保存；帳號註銷完成後立即刪除或者做匿名化處理；</p>
    <p>2. 直播內容、互動留言記錄：直播結束後留存30日；用戶手動刪除內容則即刻清除；</p>
    <p>3. 設備與操作日誌：最長保存6個月，到期自動匿名化，移除所有能夠識別個人身份的字段；</p>
    <p>4. 主播實名認證資料：賬號註銷之後留存3個月，到期依法刪除。</p>
    <h3>6.2 資訊安全保護措施</h3>
    <p>我們高度重視個人信息安全，同時採用技術手段與內部管理制度，防範信息洩露、篡改、丟失風險。</p>
    <p>6.2.1 技術防護：敏感資訊加密儲存與加密傳輸，部署防火牆、入侵偵測、數據備份機制，抵禦網絡攻擊；</p>
    <p>6.2.2 內部管理：制定嚴格的數據安全制度，嚴格管控員工的數據訪問權限；對接觸個人資訊的人員開展隱私培訓考核，簽署保密協議，禁止私自獲取、外泄用戶資料；</p>
    <p>6.2.3 安全事件應急：一旦發生個人信息洩露、篡改、丟失等安全事故，我方會立刻啟動應急方案，採取補救手段避免損害擴大，並按照法規要求通知受影響用戶與監管機構。</p>
    <h2>七、用戶個人信息相關權利</h2>
    <p>依據相關法律規範，對於您自身的個人信息，您享有查詢、更正、刪除、賬號註銷、撤回授權、投訴申訴等權利，我方提供便捷渠道供您行使權利。</p>
    <p>7.1 查詢與修改資訊：您可以進入應用內「我的」‑「個人資料」頁面，自行調整暱稱、頭像、手機號；如需調取更深層次的資訊處理記錄，可以聯繫客服處理；</p>
    <p>7.2 刪除個人內容：直播片段、評論、互動消息，您可直接在APP內手動刪除；如需清除設備日誌這類系統級記錄，需要提交客服，完成身份核驗後由我方協助處理；</p>
    <p>7.3 帳號註銷：進入「我的」&gt;「帳號設置」選擇帳號註銷，跟隨頁面指引完成申請流程。帳號註銷生效後，我方將清除或者匿名化全部對應的個人資訊；</p>
    <p>7.4 撤回權限授權：在手機系統設置關閉相機、麥克風、相簿權限即可完成撤回；撤回後不再採集該權限對應數據，但不會影響此前已經留存的資訊，其餘功能不受干擾；</p>
    <p>7.5 關閉消息推送：可以在本應用「我的」‑「消息設置」關閉推送，也可以在作業系統設置禁止本應用發送通知；</p>
    <p>7.6 投訴與申訴：如果您認為我方資訊處理行為損害自身權益，或是存有疑問，請聯繫我們提交反饋；我們會在收到請求起7個工作日內完成回覆處理。</p>
    <h2>八、未成年人信息保護</h2>
    <p>8.1 本應用並非面向未滿十八週歲未成年人設計。如果您尚未年滿18週歲，請在法定監護人陪同下閱讀本隱私政策，取得監護人同意之後才可以使用本應用；未成年人不允許開通主播直播權限。</p>
    <p>8.2 我方不會主動收集未成年人的個人信息。如果我方發現未成年人在沒有監護人許可的前提下提交個人資料，我方會儘快刪除相關信息並嘗試通知監護人。</p>
    <p>8.3 監護人如果發現未成年人未經許可使用本應用並且發生信息洩露，可聯繫我們，我們將配合核驗身份，執行刪除信息、限制帳號等對應處置。</p>
    <h2>九、隱私政策版本更新</h2>
    <p>隨著法律法規修訂或者產品功能迭代，我方有權調整、補充本隱私政策條款，新版本將進一步完善個人信息保護機制。</p>
    <p>9.1 更新告知：政策修訂完畢之後，我方通過應用彈窗、平台公告、消息通知向用戶公示，新版本自發布當日生效；</p>
    <p>9.2 用戶選擇權：如果您不接受更新後的隱私政策，應當停止使用本應用；繼續使用產品即代表您認可新版本全部條款。</p>
    <h2>十、聯繫渠道</h2>
    <p>如對本隱私政策存有疑問、建議，或是需要行使個人信息權利、提交投訴申訴，歡迎通過以下渠道與我方取得聯繫。</p>
    <ul>
    <li>運營主體：香港推衍智能科技有限公司</li>
    </ul>
    <p>－聯繫地址：RM A8, UNIT A, 5/F, TAK WING INDUSTRIAL BUILDING, 3 TSUN WEN ROAD, TUEN MUN, HONG KONG</p>
    <p>－聯絡電話：+852 51427983</p>
    <p>－聯繫電郵：dbandrewxu@gmail.com</p>
    <p>我方將在收到您消息後的7個工作日內予以回覆並處理。</p>
    <p>本隱私政策自發佈之日起生效。</p>
  `,
  'en': `
    <h1>Privacy Policy</h1>
    <p>Updated on: September 28, 2026</p>
    <p>Welcome to the LIVEO APP (hereinafter referred to as "this Application") developed and operated by Hong Kong Tuiyan Intelligent Technology Co., Ltd. (hereinafter referred to as "we" or "us"). This Privacy Policy provides users with a comprehensive explanation of our mechanisms for collecting, using, storing, sharing, and protecting personal information. It also outlines the various information-related rights you enjoy, helping you fully understand the relevant rules and make an informed decision on whether to provide us with personal information.</p>
    <p>Before using all services of this application, please read all terms of this privacy policy thoroughly. <strong>If you do not agree with any terms in this policy, please stop using this application immediately.</strong></p>
    <h2>I. General Provisions</h2>
    <p>We strictly adhere to the principles of legality, fairness, and data minimization when handling your personal information. We only collect data to fulfill the core business of live streaming on this application, and will not obtain user information unrelated to our product services.</p>
    <p>This policy applies to all scenarios of your use of the LIVEO APP, encompassing all functions such as registration and login, live streaming viewing, live streaming broadcasting, commenting and interaction, recharge and consumption, and customer service inquiries. For data processing activities on external webpages and third-party SDKs, the privacy regulations of the respective third party shall prevail.</p>
    <h2>II. Categories of personal information collected</h2>
    <p>We only collect corresponding information with your authorization or when necessary for completing the service. The sources of information are divided into two categories: information you actively submit and information automatically collected by the system.</p>
    <h3>2.1 Account registration and login to obtain information</h3>
    <p>To assist you in creating and logging into a LIVEO live streaming account, and to ensure the security of your account and the normal use of live streaming and interactive-related features, we may collect the following information:</p>
    <p>2.1.1 Mobile phone number and SMS verification code: used for account registration and identity verification, to prevent security risks such as malicious bulk registration;</p>
    <p>2.1.2 User-defined nickname and avatar image: You can set it yourself for identity display in live streaming scenarios, facilitating recognition and interaction with other users.</p>
    <h3>2.2 Equipment, network, and log data</h3>
    <p>When you run this application, the system will automatically record device parameters, network environment, and operation logs; the purpose is to ensure stable program operation, optimize live streaming experience, and resist various security risks.</p>
    <p>2.2.1 Device information: device model, operating system version, device identifiers (such as OAID, Android ID, IDFA, etc.), and device operating status. These identifiers are only used to distinguish devices and will not directly link to your real personal identity;</p>
    <p>2.2.2 Network information: IP address, MAC address, network type (WiFi, 4G/5G, etc.), network quality status, used to evaluate the network environment and ensure smooth live streaming playback;</p>
    <p>2.2.3 Operation and Crash Logs: Record your usage behaviors, such as entering/exiting live streaming rooms, sending comments, liking, as well as application crashes, loading exceptions, etc., for locating program defects and iteratively optimizing product performance.</p>
    <h3>2.3 Information actively uploaded and submitted by users</h3>
    <p>When using live streaming-related functions, depending on the functional requirements, you may proactively submit the following content to the platform:</p>
    <p>2.3.1 Live broadcast output content: live broadcast footage captured by cameras, audio recorded by microphones, manually uploaded album pictures, comment texts, interactive messages, etc;</p>
    <p>2.3.2 Customer service feedback information: When you inquire, make suggestions, or initiate complaints through customer service channels, you may provide your name, contact phone number, email address, and a description of the issue to assist us in handling your requests.</p>
    <h3>2.4 Collection information corresponding to device permissions</h3>
    <p>To fulfill the core function of live streaming, this application will request device permissions from you. You have the autonomy to choose whether to grant or deny the authorization. Denying a specific permission will only render the corresponding function unavailable, without interfering with the normal use of other modules.</p>
    <p>2.4.1 Camera permission: It will only be invoked when you initiate live streaming shooting, and is used to capture live streaming footage; the application will not access the camera without your permission when it is idle in the background;</p>
    <p>2.4.2 Microphone permission: It is only enabled in scenarios such as starting a live broadcast or sending voice messages, and is responsible for recording audio; no sound will be recorded in the background state;</p>
    <p>2.4.3 Access permission to photo albums: When selecting uploaded images as live broadcast covers, backgrounds, or interactive materials, the selected images will be read, and there will be no active scanning of all files in the photo album.</p>
    <h2>III. Scope of use of personal information</h2>
    <p>All personal information we obtain will only be used for legitimate business scenarios as listed below. If there is a subsequent need to use data beyond the scope of this policy, we will obtain your explicit permission separately.</p>
    <p>3.1 Complete account creation, login, and identity verification to prevent account theft and malicious registration, and ensure account security;</p>
    <p>3.2 Provide core live streaming services, including image capture, audio recording, content display, commenting, liking, and interactive voice chat, to ensure the normal operation of live streaming business;</p>
    <p>3.3 Improve product experience, troubleshoot program faults based on operation records, device and network information, optimize live streaming fluency, and iterate functional design;</p>
    <p>3.4 Implement security risk control measures, relying on device information and behavior logs to identify abnormal behaviors such as cheating, unauthorized live streaming, and account theft, in order to maintain platform order and protect the legitimate rights and interests of all users;</p>
    <p>3.5 Handle customer service requests, respond to inquiries and handle complaints based on the contact information you provided, and follow up on the progress of matter handling;</p>
    <p>3.6 Push necessary system notifications, including account security reminders, live streaming prompts, interactive messages, and policy update announcements;</p>
    <p>3.7 Fulfill legal obligations, cooperate with judicial and regulatory authorities in investigation and evidence collection, and implement legal requirements such as real-name authentication and verification of violations.</p>
    <h2>IV. Sharing, Transfer, and Public Disclosure of Personal Information</h2>
    <p>We will strictly protect your personal information, adhering to the principles of legality, propriety, and minimal necessity; unless in accordance with this policy, we will not arbitrarily share, transfer, or disclose user information externally.</p>
    <h3>4.1 Applicable scenarios of information sharing</h3>
    <p>Only in the following scenarios, we will deliver necessary information to third parties, while reviewing their qualifications and requiring them to undertake confidentiality obligations:</p>
    <p>4.1.1 Third-party SDK service providers: To achieve product capabilities such as live streaming, data statistics, and message push, this application integrates third-party SDK components. The SDK only collects data that is essential for completing the corresponding functions, and each service provider needs to follow their own privacy regulations when handling user data.</p>
    <p>4.1.1.1 Live streaming SDK: It completes streaming push, streaming pull, and microphone connection interaction, and acquires device parameters, network conditions, and live streaming audio and video content;</p>
    <p>4.1.1.2 Statistics SDK: Collects data on product activity, live streaming duration, and user operational behavior. It only gathers device and log information, without collecting sensitive data that can identify individuals, for use as a reference in product iteration;</p>
    <p>4.1.1.3 Push SDK: responsible for delivering broadcast notifications, account security reminders, obtaining device identifiers, pushing operation logs, and ensuring normal delivery of notifications.</p>
    <p>4.1.2 Group Affiliated Enterprises: If our affiliated enterprises need assistance in providing services (such as account interoperability, revenue settlement, etc.), we will first obtain your consent before sharing necessary data. These affiliated enterprises are also bound by this Privacy Policy.</p>
    <p>4.1.3 Statutory and Regulatory Requirements: In the event of explicit legal, judicial, or regulatory requirements, we will submit the necessary personal information in accordance with the law and cooperate with investigations and compliance verifications.</p>
    <h3>4.2 Information transfer</h3>
    <p>In principle, we will not proactively transfer your personal information. If there is a corporate merger, division, acquisition, or asset disposal that necessitates the transfer of personal information, we will notify users at least 30 days in advance through application pop-ups or announcements, and will only proceed with the transfer after obtaining your explicit consent. At the same time, we will require the transferee to assume the same standard of privacy protection responsibility. If the transferee fails to fulfill its protection obligations, we will bear the corresponding joint and several liability in accordance with the law.</p>
    <h3>4.3 Public disclosure</h3>
    <p>Without your explicit permission, we will not disclose your personal information to the public, unless it falls under the following circumstances:</p>
    <p>4.3.1 Subject to your active authorization, we will disclose relevant content according to your wishes, such as sharing live broadcast footage externally by yourself;</p>
    <p>4.3.2 To safeguard public interests, maintain platform order, or protect user rights, we will disclose the outcomes of handling violations, but all sensitive information that can be traced back to individual identities will be blocked.</p>
    <h3>4.4 Special Notes</h3>
    <p>We will not sell, rent, or lend users' personal information, nor will we apply personal data to any illegal scenarios.</p>
    <h2>V. List of Third-party SDKs</h2>
    <p>To ensure the stable operation of this application, this product integrates the following third-party SDKs; if new third-party components are added in the future, we will update this clause through application announcements.</p>
    <p>SDK Name: ZEGO_Real-time Audio and Video SDK</p>
    
    <p>Purpose: To provide voice call, live streaming and streaming pull services</p>
    <p>Types of personal information collected: network connection information, camera, audio, external storage read and write permissions</p>
    <p>Cooperation partner: Shenzhen Jigou Technology Co., Ltd</p>
    <p>Collection method: Self-collection by SDK</p>
    <p>Partner Privacy Policy: <a href="https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy" target="_blank" rel="noopener noreferrer">https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy</a></p>
    <p>SDK Name: ZEGO_AI Beauty SDK</p>
    
    <p>Purpose: To provide live streaming beauty enhancement and special effects functions</p>
    <p>Types of personal information collected: facial feature values, iris, username, user ID, operation logs, App version number, device ID, operating system type, IP address</p>
    <p>Cooperation partner: Shenzhen Jigou Technology Co., Ltd</p>
    <p>Collection method: Self-collection by SDK</p>
    <p>Partner Privacy Policy: <a href="https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy" target="_blank" rel="noopener noreferrer">https://doc-zh.zego.im/policies-and-agreements/zego-sdk-privacy-policy</a></p>
    <p>You can click on the link above to view the privacy policies of various service providers. If you do not agree with the information collection practices of a particular SDK, you can choose not to use the corresponding functions of that SDK, or simply uninstall the application.</p>
    <h2>VI. Information storage and security protection mechanism</h2>
    <h3>6.1 Data storage</h3>
    <ul>
    <li>Storage Location: The personal information we collect is stored on Alibaba Cloud servers in Singapore, which complies with relevant laws and regulations regarding the cross-border storage of personal information. If, due to service requirements, the information needs to be stored in other overseas regions, we will obtain your explicit consent in advance and conduct security assessments and filing in accordance with relevant regulations.</li>
    <li>Storage duration: Adhering to the principle of minimum necessity and shortest retention, the retention periods for different categories of data are as follows:</li>
    </ul>
    <p>1. Basic account information (phone number, nickname, avatar, etc.): It will be continuously saved during the account's existence; upon account cancellation, it will be immediately deleted or anonymized;</p>
    <p>2. Live broadcast content and interactive message records: retained for 30 days after the live broadcast ends; if the user manually deletes the content, it will be instantly cleared;</p>
    <p>3. Equipment and operation logs: They are stored for up to 6 months and will be automatically anonymized upon expiration, with all personally identifiable fields removed;</p>
    <p>4. Anchor's real-name authentication information: retained for 3 months after account cancellation, and deleted according to law upon expiration.</p>
    <h3>6.2 Information security protection measures</h3>
    <p>We attach great importance to personal information security and employ technical measures and internal management systems to prevent the risks of information leakage, tampering, and loss.</p>
    <p>6.2.1 Technical protection: Encrypted storage and transmission of sensitive information, deployment of firewalls, intrusion detection, and data backup mechanisms to resist network attacks;</p>
    <p>6.2.2 Internal management: Establish a strict data security system and strictly control employees' data access permissions; conduct privacy training and assessments for personnel who come into contact with personal information, require them to sign confidentiality agreements, and prohibit them from obtaining or leaking user information without authorization;</p>
    <p>6.2.3 Emergency response to security incidents: In the event of security incidents such as personal information leakage, tampering, or loss, we will immediately initiate an emergency response plan, take remedial measures to prevent further damage, and notify affected users and regulatory authorities in accordance with regulatory requirements.</p>
    <h2>VII. Rights related to user personal information</h2>
    <p>In accordance with relevant legal regulations, you have the right to inquire about, correct, delete, cancel your account, withdraw authorization, lodge complaints, and appeal regarding your personal information. We provide convenient channels for you to exercise these rights.</p>
    <p>7.1 Inquiry and modification of information: You can enter the "My" - "Personal Information" page within the application to adjust your nickname, avatar, and mobile phone number; if you need to access deeper information processing records, you can contact customer service for assistance;</p>
    <p>7.2 Deleting personal content: You can manually delete live broadcast clips, comments, and interactive messages directly within the app; if you need to clear system-level records such as device logs, you need to submit it to customer service and we will assist in processing after completing identity verification;</p>
    <p>7.3 Account cancellation: Navigate to "My" &gt; "Account Settings" and select "Account Cancellation". Follow the on-screen instructions to complete the application process. Once the account cancellation takes effect, we will either delete or anonymize all corresponding personal information;</p>
    <p>7.4 Withdrawal of permission authorization: The withdrawal can be completed by turning off the camera, microphone, and album permissions in the phone's system settings; after withdrawal, data corresponding to that permission will no longer be collected, but it will not affect the information that has been stored previously, and other functions will not be interfered with;</p>
    <p>7.5 Disable message push notifications: You can disable push notifications in the app by going to "My" -&gt; "Message Settings", or you can disable notifications sent by the app in the operating system settings;</p>
    <p>7.6 Complaints and Appeals: If you believe that our information processing behavior has harmed your rights and interests, or if you have any questions, please contact us to submit feedback; we will respond and handle within 7 working days from the receipt of the request.</p>
    <h2>VIII. Protection of Minors' Information</h2>
    <p>8.1 This application is not designed for minors under the age of 18. If you are under 18, please read this Privacy Policy accompanied by your legal guardian and obtain your guardian's consent before using this application; minors are not allowed to open the live streaming permission.</p>
    <p>8.2 We will not proactively collect personal information from minors. If we discover that a minor has submitted personal information without the permission of their guardian, we will promptly delete the relevant information and attempt to notify the guardian.</p>
    <p>8.3 If guardians discover that minors have used this application without permission and information has been leaked, they can contact us. We will cooperate with them to verify their identity and take corresponding measures such as deleting information and restricting accounts.</p>
    <h2>IX. Update of Privacy Policy Version</h2>
    <p>With the revision of laws and regulations or product function iterations, we reserve the right to adjust and supplement the terms of this Privacy Policy. The new version will further enhance the personal information protection mechanism.</p>
    <p>9.1 Update notification: After the policy revision is completed, we will notify users through application pop-ups, platform announcements, and message notifications. The new version will take effect on the day it is released;</p>
    <p>9.2 User's Right to Choose: If you do not accept the updated privacy policy, you should stop using this application; continuing to use the product means that you acknowledge all terms of the new version.</p>
    <h2>X. Contact Channels</h2>
    <p>If you have any questions, suggestions regarding this Privacy Policy, or need to exercise your personal information rights, submit complaints or appeals, please feel free to contact us through the following channels.</p>
    <ul>
    <li>Operating entity: Hong Kong Tuiyan Intelligent Technology Co., Ltd</li>
    <li>Contact address: RM A8, UNIT A, 5/F, TAK WING INDUSTRIAL BUILDING, 3 TSUN WEN ROAD, TUEN MUN, HONG KONG</li>
    <li>Contact number: +852 51427983</li>
    <li>Contact email: dbandrewxu@gmail.com</li>
    </ul>
    <p>We will respond and handle your message within 7 working days upon receipt.</p>
    <p>This Privacy Policy shall come into effect from the date of its publication.</p>
  `
}

const supportedLangs = ['zh-Hans', 'zh-Hant', 'en']

export default {
  name: 'PrivacyPolicy',
  setup () {
    const route = useRoute()
    const currentLang = computed(() => {
      const rawLang = (route.query.lang || '').toString()
      if (supportedLangs.includes(rawLang)) {
        return rawLang
      }

      return 'zh-Hant'
    })
    const contentHtml = computed(() => agreementTexts[currentLang.value] || agreementTexts['zh-Hant'])
    document.title = computed(() => {
      switch (currentLang.value) {
        case 'zh-Hans': return 'LIVEO APP隐私政策'
        case 'zh-Hant': return 'LIVEO APP隱私政策'
        case 'en': return 'LIVEO APP Privacy Policy'
        default: return 'LIVEO APP隱私政策'
      }
    }).value
    return { contentHtml }
  }
}
</script>

<style scoped>
/* 隐私政策页独立浅色文档样式，与用户协议一致 */
.agreement-page {
  min-height: 100vh;
  box-sizing: border-box;
  background: #fff;
  color: #333;
  padding: 20px 16px 32px;
}

.agreement {
  max-width: 760px;
  margin: 0 auto;
  text-align: left;
  font-size: 17px;
  line-height: 1.47;
  -webkit-text-size-adjust: 100%;
  color: #333;
}

.agreement :deep(h1) {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.27;
  color: #000;
}

.agreement :deep(h2) {
  margin: 20px 0 10px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.25;
  color: #000;
}

.agreement :deep(h3) {
  margin: 14px 0 8px;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.47;
  color: #000;
}

.agreement :deep(p) {
  margin: 0 0 12px;
  font-size: 17px;
  line-height: 1.47;
  color: #333;
}

.agreement :deep(ul) {
  margin: 0 0 12px;
  padding-left: 1.25em;
}

.agreement :deep(li) {
  margin: 0 0 8px;
  font-size: 17px;
  line-height: 1.47;
  color: #333;
}

.agreement :deep(a) {
  color: #0066cc;
  word-break: break-all;
}

.agreement :deep(strong) {
  font-weight: 700;
  color: #000;
}
</style>
